// PC-specific JavaScript
// Import jQuery from npm and expose it globally IMMEDIATELY
import $ from 'jquery'

// Expose jQuery to global scope BEFORE any imports
window.$ = $;
window.jQuery = $;

// Import jQuery plugins and main script synchronously
// jQuery is already exposed globally, so no need for setTimeout
import '../javascripts/lib/jquery.cookie.js';
import '../javascripts/lib/jquery.bxslider.js';
import '../javascripts/pc/main.js';
import '../javascripts/shindan.js';
